// Copyright (c) 2016 Deere & Company

import './labeled-link.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const composeClasses = className => className ?
    `labeled-link ${className}` :
    'labeled-link';

const LabeledLink = ({className, label, data, href, ...props}) =>
    <div className={composeClasses(className)}>
        <span className='data-label'>
            <FormattedMessage id={label}/>
        </span>
        <span className='data-key'>
            {href ?
                <a
                    href={href}
                    {...props}
                >
                    {data}
                </a> : data}
        </span>
    </div>;

LabeledLink.displayName = 'LabeledLink';
LabeledLink.propTypes = {
    className: PropTypes.string,
    data: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
};

export default LabeledLink;



// WEBPACK FOOTER //
// ./src/product/shared/components/labeled-link.js